import { element } from 'protractor';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { NutritionComponent } from '../../nutrition.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';

@Component({
  selector: 'vex-compose-diet',
  templateUrl: './compose-diet.component.html',
  styleUrls: ['./compose-diet.component.scss',
    '../../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../../@vex/styles/partials/plugins/quill/_quill.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class ComposeDietComponent implements OnInit {
  nutrition = {
    dailyKcal: "",
    energyRequirement: "",
    carbohydrates: "",
    fats: "",
    protein: "",
    physicalActivityLevel: "",
    mb: "",
    note: ""
  };

  recipes = [];
  searchCtrl = new UntypedFormControl();
  filter = {
    selectedCategory: "",
    selectedTags: ""
  };
  categories = [
    { key: 'colazione', description: 'Colazione' },
    { key: 'merenda', description: 'Merenda' },
    { key: 'pranzo', description: 'Pranzo' },
    { key: 'cena', description: 'Cena' }
  ];
  availableTags: string[] = ['Senza glutine', 'Senza lattosio', 'Vegetariano', 'Vegano', 'Salate', 'Dolce'];
  pageSize = 10;
  pageNumber = 1;
  lunghezza: any;
  environmentNode = environment.baseURL.node;
  selectedRecipe;
  recipeToSend = {
    colazione: [],
    pranzo: [],
    cena: [],
    spuntini: []
  };
  currentStep = 0;
  recipeKeys = Object.keys(this.recipeToSend);
  mealCategories = [];
  expandedCardId: string | null = null;
  ingredients = {};
  dietStatus;
  userInfoAccordion: boolean = false;
  expandedIngredientId = null;
  editingRecipeInfo: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'], public guiService: GuiService, public translate: TranslateService, private restService: RestService, private dialogRef: MatDialogRef<NutritionComponent>, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getMealCategories();
    this.getIngredients();
    console.debug(this.item)
    this.item.survey.diet ? this.populateDiet() : null;
  }

  populateDiet() {
    this.restService.postService('node', '/get-diet', { userId: this.guiService.userLogged.user.id, dietId: this.item.survey.diet.documentFileName }).subscribe((ris) => {
      console.debug('diet response', ris);
      this.dietStatus = ris.status;
      this.nutrition = ris.infos;
      this.recipeToSend = ris.recipes;
      this.mealCategories = ris.dishComposeInfos;
    })
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

  search(resetPage?:boolean) {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    resetPage ? (this.pageNumber = 1, this.paginator.pageIndex = 0) : null;
    const param = {
      page: this.pageNumber,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };

    this.selectedRecipe = null;

    this.searchCtrl.value && this.searchCtrl.value !== '' ? (param['langKey'] = this.translate.currentLang.toUpperCase(), param['i18nTitleFilter'] = this.searchCtrl.value) : null;
    this.filter.selectedTags && this.filter.selectedTags !== '' ? param['tagFilter'] = this.filter.selectedTags : null;
    this.filter.selectedCategory && this.filter.selectedCategory !== '' ? param['categoryFilter'] = this.filter.selectedCategory : null;

    this.restService.postService('node', '/recipes-list', param).subscribe((ris) => {
      this.recipes = ris.items;
      this.lunghezza = ris.totalItems;
      this.guiService.showSpinner = false;
    })
  }

  getMealCategories() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('node', '/meal-dish-compose', { userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      this.mealCategories = ris;
      this.guiService.showSpinner = false;
    })
  }

  addSelectedRecipeTo(to: string) {
    if (this.selectedRecipe) {
      this.recipeToSend[to].push(JSON.parse(JSON.stringify(this.selectedRecipe)));
      const lastIndex = this.recipeToSend[to].length - 1;
      this.setFullIngredients(this.recipeToSend[to][lastIndex]);
      this.selectedRecipe = null;
    }
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  nextStep() {
    this.currentStep++;
    this.expandedCardId = null;
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.expandedCardId = null;
    }
  }

  setCurrentStep(step: number) {
    this.currentStep = step;
  }

  deleteRecipe(recipe) {
    const stepKey = this.recipeKeys[this.currentStep];
    const recipeIndex = this.recipeToSend[stepKey].indexOf(recipe);
    if (recipeIndex !== -1) {
      this.recipeToSend[stepKey].splice(recipeIndex, 1);
    }
  }

  areAllFoodsFilled(): boolean {
    return this.mealCategories.every(obj =>
      obj.foods.every(food =>
        food.value && food.value.trim() !== ''
      )
    );
  }

  areAllNutritionalValuesFilled(): boolean {
    return Object.values(this.nutrition).every(value => value !== null && value !== '');
  }

  areAllMealsComplete(): boolean {
    const allowedUnits = ['a.n.', 'q.b.', 'as needed', 'quanto basta'];

    return Object.values(this.recipeToSend).every(arr =>
      Array.isArray(arr) &&
      arr.length >= 1 &&
      arr.every(item =>
        item.ingredientsFull &&
        Object.values(item.ingredientsFull).every((ingredient: any) =>
          allowedUnits.includes(ingredient.unit?.en) ||
          allowedUnits.includes(ingredient.unit?.it) ||
          (ingredient.quantity !== "" && ingredient.quantity !== null)
        )
      )
    );
  }

  areSingleMealCompleted(obj: Object): boolean {
    const allowedUnits = ['a.n.', 'q.b.', 'as needed', 'quanto basta'];

    return Object.values(obj).every((item: any) =>
      allowedUnits.includes(item.unit?.en) ||
      allowedUnits.includes(item.unit?.it) ||
      (item.quantity !== "" && item.quantity !== null)
    );
  }

  send() {
    const objToSend = {
      infos: this.nutrition,
      recipes: this.recipeToSend,
      dishComposeInfos: this.mealCategories,
      userId: this.guiService.userLogged.user.id,
      surveyId: this.item.survey.id,
      extUserEmail: this.item.userEmail,
      extUserId: this.item.survey.userId,
      nutriEmail: this.guiService.userLogged.user.email
    };

    this.item.survey.diet ? objToSend['tmpDiet'] = this.item.survey.diet.documentFileName : null;

    if (this.areAllMealsComplete() && this.areAllFoodsFilled() && this.areAllNutritionalValuesFilled()) {
      console.debug('TUTTI I CAMPI SONO STATI RIEMPITI');

      objToSend['status'] = 'send';
      setTimeout(() => this.guiService.showSpinner = true, 0)
      this.restService.postService('node', '/set-diet', objToSend).subscribe((ris) => {
        console.debug(ris);
        this.guiService.showSpinner = false;
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.DIET_LOAD'), this.translate.instant('GLOBAL.CLOSE'));
        this.dialogRef.close('done');
      })

    } else {
      console.debug('NON SONO STATI COMPILATI TUTTI I CAMPI');

      objToSend['status'] = 'draft';
      setTimeout(() => this.guiService.showSpinner = true, 0)
      this.restService.postService('node', '/set-diet', objToSend).subscribe((ris) => {
        console.debug(ris);
        this.guiService.showSpinner = false;
        !this.item.survey.diet ? this.dialogRef.close('done') : null;
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.SAVED'), this.translate.instant('GLOBAL.CLOSE'));
      })
    }

  }

  onEdit(item: any, index): void {
    console.debug('item', item)
    this.expandedCardId = item._id + '_' + index;
  }

  setFullIngredients(item) {
    console.debug(item)
    item.ingredientsFull = {};
    item.ingredients.forEach(element => {
      item.ingredientsFull[element] = JSON.parse(JSON.stringify(this.ingredients[element]));
    });
  }

  getIngredients() {
    setTimeout(() => this.guiService.showSpinner = true, 0);
    this.restService.postService('node', '/ingredients-list', { userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      ris.forEach(element => {
        this.ingredients[element._id] = element;
        this.ingredients[element._id].quantity = '';
      });
      this.guiService.showSpinner = false;
    })
  }

  getEmptySpace(objLength) {
    const emptyCount = 7 - objLength;
    return Array(emptyCount)
  }

  duplicateRecipe(recipe) {
    const stepKey = this.recipeKeys[this.currentStep];
    if (this.recipeToSend[stepKey].length < 7) {
      this.recipeToSend[stepKey].push((JSON.parse(JSON.stringify(recipe))));
    }
  }

  moveRight(index) {
    if (index < 7) {
      const stepKey = this.recipeKeys[this.currentStep];
      const tmpItem = this.recipeToSend[stepKey][index];
      this.recipeToSend[stepKey][index] = this.recipeToSend[stepKey][index + 1];
      this.recipeToSend[stepKey][index + 1] = tmpItem;
    }
  }

  moveLeft(index) {
    if (index > 0) {
      const stepKey = this.recipeKeys[this.currentStep];
      const tmpItem = this.recipeToSend[stepKey][index];
      this.recipeToSend[stepKey][index] = this.recipeToSend[stepKey][index - 1];
      this.recipeToSend[stepKey][index - 1] = tmpItem;
    }
  }

  editRecipeIngredient(id) {
    this.expandedIngredientId = id;
  }

  saveRecipeIngredient() {
    this.expandedIngredientId = null;
  }

  editRecipeInfo() {
    this.editingRecipeInfo = true;
  }

  saveRecipeInfo() {
    this.editingRecipeInfo = false;
  }

  reduceExpand(){
    this.editingRecipeInfo = false;
    this.expandedCardId = null;
  }
}
